const translations = {
    en: {
        mail_unsubscribe: {
            mail_unsubscribe_authorization: "I don’t want to receive other email communications about this stay from Best Western Italy S.c.p.a. ",
            mail_unsubscribe_confirmation: "We have received your request. You will not receive other email communications about this stay.",
            unsubscribe: "Unsubscribe",
            no: "No"
        }
    },
    de: {
        mail_unsubscribe: {
            mail_unsubscribe_authorization: "Ich ermächtige nicht mehr Best Western Italia S.c.p.a. betreffende unterlagen zu schicken",
            mail_unsubscribe_confirmation: "Wir haben ihre Anfrage erhalten. Sie erhalten keine weiteren E-Mails über diesen Aufenthalt.",
            unsubscribe: "Abmelden",
            no: "Nein"
        }
    },
    es: {
        mail_unsubscribe: {
            mail_unsubscribe_authorization: "Autorizo Best Western Italia S.c.p.a. a enviarme comunicaciones relativas a mi estancia ",
            mail_unsubscribe_confirmation: "Hemos recibido su petición. No recibirás otras comunicaciones por correo electrónico sobre esta estadía.",
            unsubscribe: "Darse de baja",
            no: "No"
        }
    },
    fr: {
        mail_unsubscribe: {
            mail_unsubscribe_authorization: "J'autorise Best Western Italia S.c.p.a. pour m'envoyer la communication liée à mon séjour",
            mail_unsubscribe_confirmation: "Nous avons reçu votre demande. Vous ne recevrez pas d'autres communications par e-mail à propos de ce séjour.",
            unsubscribe: "Se désinscrire",
            no: "Non"
        }
    },
    it: {
        mail_unsubscribe: {
            mail_unsubscribe_authorization: "Non desidero più ricevere comunicazioni via email relative a questo soggiorno da Best Western Italia S.c.p.a.",
            mail_unsubscribe_confirmation: "Abbiamo ricevuto la tua richiesta. Non riceverai ulteriori email relative a questo soggiorno.",
            unsubscribe: "Disiscrivimi",
            no: "No"
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/mail_unsubscribe/MailUnsubscribe.js